import { GameScatterPickCoconutProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameScatterPickCoconutProperties";
export class ScatterPickCoconutPortraitProperties extends GameScatterPickCoconutProperties {
    constructor() {
        super();
        this.position.set(512, 973);
        this.scale.set(0.73);
        this.coconutSpineProperties.position.set(0, 130);
    }
}
//# sourceMappingURL=ScatterPickCoconutPortraitProperties.js.map